import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import classes from "./KioskFoodCardOptions.module.scss"
import { languageSuffixMap } from "constant"
import { LazyImage } from "components"
import { thousandSeparator } from "utils"

const KioskFoodCardOptions = props => {
  const {
    food,
    setQuantity,
    selectedOption,
    setSelectedOption
  } = props

  const [t, i18n] = useTranslation()

  const getOptionImage = (optionIndex) => {
    const index =
      food.imagePerOptions?.[optionIndex]

    if (index < 0) return food.imageCover

    return food.images[index] || food.imageCover
  }

  const handleSelect = (option) => {
    if (isOutOfStock(option)) return

    setQuantity(1)

    setSelectedOption(option)
  }

  const isOutOfStock = (option) => (
    option.outOfStock ||
    (
      option.stockManagement &&
      option.availableQuantity <= 0
    )
  )

  if (food.options.length === 1) return null

  return (
    <div className={classes["container"]}>
      <div className={classes["header"]}>
        {t("انتخاب_نوع")}
      </div>

      <div className={classes["options"]}>
        {food.options.map((option, optionIndex) =>
          option.isAvailable && !isOutOfStock(option) &&
          <div
            key={option._id}
            onClick={() => handleSelect(option)}
            className={clsx(classes["option"],
              selectedOption?._id === option._id && classes["active"]
            )}
          >
            <LazyImage
              src={getOptionImage(optionIndex)}
              imageWidth={300}
              quality={80}
              className={classes["image"]}
            />

            <div className={classes["footer"]}>
              <span className={classes["option-name"]}>
                {option[`name${languageSuffixMap[i18n.language]}`]}
              </span>

              <span className={classes["price"]}>
                {thousandSeparator(option.salePrice)}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default KioskFoodCardOptions
